import axios from "axios";

const INITIAL_STATE = {
  formsSignup: {},
};

const state = () => INITIAL_STATE;

const actions = {
  async fetchFormsSignup({ commit, dispatch, rootState }, { conferenceId = 5 }) {
    try {
      const accessToken = rootState.user.token;
      const { status, data } = await axios.get(
        process.env.VUE_APP_API_URL + "/conference/forms/signup",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            conferenceId: conferenceId,
          },
        }
      );

      if (status !== 200) throw new Error("Failed in getting signups");
      commit("setFormsSignup", { conferenceId, data });
    } catch (e) {
      dispatch("toast/error", "Failed to fetch signups.", {
        root: true,
      });
      throw e;
    }
  },
};

const mutations = {
  setFormsSignup(state, { conferenceId, data}) {
    const formsSignup = state.formsSignup
    formsSignup[conferenceId] = data;
    state.formsSignup = formsSignup
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
